import paths from "../../shared/route/paths";
import CompanyPage from "./Company.page";

export const CompanyModule = {
  isPrivate: true,
  routers: {
    path: paths.COMPANY,
    component: CompanyPage,
  },
};
